var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var HomeBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var _a = store.newCreateRequestStore, progressStore = _a.progressStore, problemStore = _a.problemStore, homeStore = _a.homeStore, commonStore = _a.commonStore;
    var propsConnect = {
        currentUser: homeStore.currentUser,
        getGreetingText: homeStore.getGreetingText,
        nextScheduledData: homeStore.nextScheduledData,
        notScheduledWoData: homeStore.notScheduledWoData,
        scheduledWoData: homeStore.scheduledWoData,
        completedWoData: homeStore.completedWoData,
        level: problemStore.level,
        currentIndex: progressStore.currentIndex,
        isRecallCheck: commonStore.isRecallCheck,
        customConfigs: store.commonStore.customConfigs,
    };
    var dispatchConnect = {
        jump: progressStore.jump,
        initProblem: problemStore.initProblem,
        getCurrentUser: homeStore.getCurrentUser,
        getNextScheduledWo: homeStore.getNextScheduledWo,
        getCompletedWoList: homeStore.getCompletedWoList,
        getScheduledWoList: homeStore.getScheduledWoList,
        getNotScheduledWoList: homeStore.getNotScheduledWoList,
        setPageTitle: store.commonStore.setTitle,
        getCustomConfigs: function () { return store.commonStore.getCustomConfigs(); },
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
